<template>
    <div id="footer">
        <div class="container">
            <div class="row justify-content-center text-center py-4">
                <div class="px-2">
                    <div>
                        <router-link to="/">
                            <img src="../../assets/logo2.png" alt="ТМ">
                        </router-link>
                    </div>
                    <div class="mt-4 qf-info-links d-flex justify-content-center">
                        <div>
                            <router-link to="/info#datenschutz">
                                {{$ml.get('DATENSCHUTZ')}}
                            </router-link>
                        </div>
                        <div class="qf-dot-before">
                            <router-link to="/info#gdpr">
                                {{$ml.get('GDPR')}}
                            </router-link>
                        </div>
                        <div class="qf-dot-before">
                            <router-link to="/info#agb">
                                {{$ml.get('AGB')}}
                            </router-link>
                        </div>
                    </div>
                </div>
                <div class="px-2">
                    <form class="qf-footer-form d-flex flex-column flex-sm-row justify-content-center" @submit.prevent="sendEmail" id="contact-form">
                        <div>
                            <input type="text" name="name" v-model="contact.name"
                                   class="mt-3 ml-3 mr-3 mb-1 p-1 pl-2" :placeholder="$ml.get('Name')"
                                   v-validate="'required'"
                                   :class="{'is-invalid': errors.has('name')}"/>
                            <small class="form-text text-danger pl-3"
                                   v-if="errorMessages.name">
                                {{errorMessages.name}}
                            </small>
                            <input type="email" name="email" v-model="contact.email"
                                   class="mt-3 ml-3 mr-3 mb-1 p-1 pl-2" :placeholder="$ml.get('email')"
                                   v-validate="'required|email'"
                                   :class="{'is-invalid': errors.has('email')}" />
                            <small class="form-text text-danger pl-3"
                                   v-if="errorMessages.email">
                                {{errorMessages.email}}
                            </small>
                            <input type="text" name="phone" v-model="contact.phone"
                                   class="mx-3 mt-3 mb-sm-3 p-1 pl-2" :placeholder="$ml.get('phone')" />
                        </div>
                        <div class="text-right">
                            <textarea name="message" v-model="contact.message"
                                      class="mt-3 ml-3 mr-3 mb-1 p-1 pl-2" :placeholder="$ml.get('how_can_we_help')"
                                      v-validate="'required'"
                                      :class="{'is-invalid': errors.has('message')}"></textarea>
                            <small class="form-text text-danger mr-3 pl-3 pr-3 text-center"
                                   v-if="errorMessages.message">
                                {{errorMessages.message}}
                            </small>
                            <font-awesome-icon icon="spinner" size="2x" class="fa-spin mt-2 mr-3" v-if="loading"/>
                            <button class="mt-2 mr-3 pl-3 pr-3" type="submit" v-if="!loading">
                                {{$ml.get('send')}}
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "myFooter",
        data() {
            return {
                contact: {
                    name: '',
                    email: '',
                    phone: '',
                    message: ''
                },
                errorMessages: {
                    name: '',
                    email: '',
                    phone: '',
                    message: ''
                },
                loading: false
            }
        },
        methods: {
            emptyForm() {
                for (let field in this.contact) {
                    this.contact[field] = null
                }
            },
            sendEmail() {
                if (!this.loading) {
                    this.errorMessages = {
                        name: '',
                        email: '',
                        phone: '',
                        message: ''
                    };
                    this.$validator.validateAll().then((result) => {
                        if (result) {
                            this.loading = true;
                            this.$store.dispatch('contact', this.contact).then(() => {
                                this.emptyForm();
                                this.loading = false;
                                this.$validator.reset();
                            }).catch(error => {
                                if (error.status === 400) {
                                    error.data.forEach(obj => {
                                        this.errorMessages[obj.property_path] = obj.message;
                                    });
                                }
                                this.loading = false;
                            });
                        }
                    });
                }
            }
        }
    }
</script>

<style scoped>
    #footer {
        color: #ffffff;
        background-color: #211f20;
        font-size: 0.8em;
    }
    .qf-info-links a {
        color: white;
    }
    .qf-info-links .qf-dot-before {
        padding-left: 18px;
    }
    .qf-info-links .qf-dot-before:before {
        top: -20px;
        left: 5px;
        font-size: 26px;
    }
    .qf-footer-form input,
    .qf-footer-form textarea {
        display: block;
        min-width: 180px;
        color: white;
        background-color: #373737;
        border-radius: 3px;
        border: none;
        font-weight: 400;
    }
    .qf-footer-form input::placeholder,
    .qf-footer-form textarea::placeholder {
        text-transform: uppercase;
    }
    .qf-footer-form input,
    .qf-footer-form textarea {
        display: block;
    }
    .qf-footer-form textarea {
        min-height: 56px;
    }
    .qf-footer-form button {
        background-color: #F7C002;
        border-radius: 3px;
        border-color: #F7C002;
        font-weight: 800;
        cursor: pointer;
    }
</style>
